import React, { useRef } from "react";
import {
    StandardModalActionButton,
    StandardModalDescription,
    StandardModalErrorText,
    StandardModalOptionCard,
    StandardModalOptionCardActions,
    StandardModalOptionCardText,
    StandardModalOptionCardTitle,
    StandardModalOptionsGrid,
    StandardModalSection
} from "src/components";
import { CsvFileHooks } from "../../hooks/csvFileHooks";
import EmailCampaignsContactsTemplate from "src/template/EmailCampaignsContactsTemplate.csv";

export default function AddContacts(props) {
    const { toggleAddSingleContact, setCsvData, errors, setErrors, audienceName, openCreateNewAudience } = props;
    const fileInputRef = useRef(null);

    const { handleCsvUpload } = CsvFileHooks(setCsvData, setErrors, openCreateNewAudience);

    const onAddSingleContact = () => {
        if (!audienceName.trim()) {
            errors.audienceName = "Audience name is required";
            setErrors({ ...errors });
            return;
        }
        toggleAddSingleContact();
    };
    const onImportCsvClick = () => {
        if (!audienceName.trim()) {
            errors.audienceName = "Audience name is required";
            setErrors({ ...errors });
            return;
        }
        fileInputRef.current.click();
    };

    return (
        <StandardModalSection>
            <StandardModalOptionCardTitle>
                Add Contacts to This Audience
            </StandardModalOptionCardTitle>
            <StandardModalDescription>
                Manually add individual users or upload a CSV file to bulk import your list. You can
                mix both methods to build your audience with ease.
            </StandardModalDescription>

            <StandardModalOptionsGrid>
                <StandardModalOptionCard $hasError={Boolean(errors.contact)}>
                    <StandardModalOptionCardText>
                        <StandardModalOptionCardTitle>Add Single Contact</StandardModalOptionCardTitle>
                        <StandardModalDescription>
                            Manually enter the details of one contact to add them to your audience list.
                        </StandardModalDescription>
                    </StandardModalOptionCardText>
                    <StandardModalActionButton
                        $variant="primary"
                        width="140px"
                        onClick={onAddSingleContact}
                    >
                        Add Contact
                    </StandardModalActionButton>
                </StandardModalOptionCard>

                <StandardModalOptionCard $hasError={Boolean(errors.contact)}>
                    <StandardModalOptionCardText>
                        <StandardModalOptionCardTitle>Import a Contact List</StandardModalOptionCardTitle>
                        <StandardModalDescription>
                            Upload a CSV file to quickly import multiple users into your audience in one
                            step.
                        </StandardModalDescription>
                    </StandardModalOptionCardText>
                    <StandardModalOptionCardActions>
                        <input
                            type="file"
                            accept=".csv"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={handleCsvUpload}
                        />
                        <StandardModalActionButton
                            $variant="primary"
                            width="180px"
                            onClick={onImportCsvClick}
                        >
                            Import CSV List
                        </StandardModalActionButton>

                        <StandardModalActionButton
                            as="a"
                            href={EmailCampaignsContactsTemplate}
                            download={"email_campaigns_contacts_template.csv"}
                            width="180px"
                        >
                            Download Template
                        </StandardModalActionButton>
                    </StandardModalOptionCardActions>
                </StandardModalOptionCard>
            </StandardModalOptionsGrid>
            {errors.contact && (
                <StandardModalErrorText>{errors.contact}</StandardModalErrorText>
            )}
        </StandardModalSection>
    );
}
